import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.27 8.411c.17.472.378.852.623 1.096.89.89 2.424.89 3.314 0 .868-.868.89-2.346.066-3.245a1.675 1.675 0 0 0-.147-.172L7 5.1c0-.3.106-.552.4-.6.294-.048.6.2.6.4l.5 3.7C9 8.4 9.8 8 10.7 8c3.9 0 5.3 3.2 5.3 5.6 0 3.7-3.3 8.4-5.1 8.4-1.2 0-1.6-.7-2.8-.7-1.3 0-1.7.7-2.9.7C3.3 22 0 17.3 0 13.6c0-1.892.893-4.28 3.27-5.189zM18.668 4l2.83 4.244A3 3 0 0 1 22 9.908V20a2 2 0 0 1-2 2h-6.94c2.044-1.755 3.94-5.48 3.94-8.4 0-3.394-2.062-6.281-5.683-6.575l2.022-3.034A1.5 1.5 0 0 1 13.5 1h5a1.5 1.5 0 0 1 .163 2.991L18.009 3h-4.008l-.665 1h5.33zM10.5 12c.1 0 .3 0 .5.1.3.2.5.4.5.9 0 .3.2.5.5.5s.5-.2.5-.5c0-.9-.4-1.5-1-1.8-.4-.1-.7-.2-1-.2-.3 0-.5.2-.5.5s.2.5.5.5zM4 7.3c-.082-.39-.1-.8-.1-1.2.358 0 .817.082 1.215.192.727.203 1.185.308 1.385.608.5.5.5 1.4 0 1.9s-1.4.5-1.9 0c-.2-.2-.44-.733-.6-1.5z"
});

var SvgItemsFilled = function SvgItemsFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgItemsFilled;